<template>
  <div class="animated fadeIn">
    <Forms ref="frmCampanhaModelo"
      :title="'CADASTRO DE CAMPANHA'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :disabledKeyUpEnter="true"
      v-on:Clear="onClear"
      v-on:Back="$emit('Back')"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label ><small v-if="form.nome.required" class="text-danger">*</small> Nome da Campanha:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome da campanha'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtName"><small v-if="form.plataforma.required" class="text-danger">*</small> Canal:</label>
          <div class="input-group">
            <b-form-select @change="hasClasseA" v-model="form.plataforma.value" :options="form.plataforma.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4" v-if="form.plataforma.value === 3" >
          <label for="txtName"><small v-if="form.provedorId.required" class="text-danger">*</small> Provedores:</label>
          <div class="input-group">
            <b-form-select v-model="form.provedorId.value" :options="form.provedorId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2" v-if="form.plataforma.value === 3 &&  form.provedorId.value && form.provedorId.value.type === 'WHATS_META'">
          <label ><small v-if="form.campanhaHsmId.required" class="text-danger">*</small> HSM:</label>
          <div class="input-group">
            <b-form-select v-model="form.campanhaHsmId.value" :options="form.campanhaHsmId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4" >
          <label ><small v-if="form.campanhaModeloId.required" class="text-danger">*</small> Modelo:</label>
          <div class="input-group">
            <b-dropdown
              variant="addon"
              no-caret
            >
              <template slot="button-content">
                <i class="fas fa-caret-down"/>
              </template>
              <b-dropdown-item @click="onAddTemplateModal"><i class="fas fa-plus text-third"/> Criar</b-dropdown-item>
              <b-dropdown-item @click="onEditTemplateModal" :disabled="form.campanhaModeloId.value === null"><i class="fas fa-edit  text-third"/> Editar</b-dropdown-item>
            </b-dropdown>
            <b-form-select v-model="form.campanhaModeloId.value" :options="form.campanhaModeloId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2" v-if="form.plataforma.value === 1">
          <label for="txtName"><small v-if="form.alias.required" class="text-danger">*</small> Alias:</label>
          <div class="input-group">
            <b-form-select @change="hasClasseA" v-model="form.alias.value" :options="form.alias.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div :class="form.plataforma.value === 1 ? 'col-md-2' : 'col-md-4' ">
          <label ><small v-if="form.situacao.required" class="text-danger">*</small> Situação:</label>
          <div class="input-group">
            <b-form-select disabled v-model="form.situacao.value" :options="form.situacao.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md">
          <label for="txtData"><small v-if="form.dataEnvio.required" class="text-danger">*</small> Data Disparo:</label>
          <b-form-input type="date"
                        id="txtData"
                        name="txtData"
                        style="height: 35px;"
                        :placeholder="$lang.Common.DatePlaceholder"
                        v-model="form.dataEnvio.value"
                        :required="form.dataEnvio.required"/>
        </div>
        <div class="col-md-2">
          <label ><small v-if="form.horarioEnvio.required" class="text-danger">*</small> Horário Disparo:</label>
          <FormulateInput
              type="time"
              name="horario"
              input-class="form-control"
              v-model="form.horarioEnvio.value"
              placeholder="Horário"
              :required="form.horarioEnvio.required"
              :state="form.horarioEnvio.state"
          />
        </div>
        <div class="col-md-4">
          <label ><small v-if="form.campanhaListaId.required" class="text-danger">*</small> Lista:</label>
          <div class="input-group">
            <b-dropdown
              variant="addon"
              no-caret
            >
              <template slot="button-content">
                <i class="fas fa-caret-down"/>
              </template>
              <b-dropdown-item @click="onAddSegmentationModal"><i class="fas fa-plus text-third"/> Criar</b-dropdown-item>
              <b-dropdown-item @click="onEditSegmentationModal" :disabled="form.campanhaListaId.value === null"><i class="fas fa-edit  text-third"/> Editar</b-dropdown-item>
            </b-dropdown>
            <b-form-select v-model="form.campanhaListaId.value" :options="form.campanhaListaId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2 pb-2">
        <div class="col-md-12">
          <label>Observações:</label>
          <div class="input-group">
            <b-form-textarea
              v-model="form.observacao.value"
              :placeholder="'Coloque suas observações aqui sobre a campanha'"
              :rows="form.observacao.rows"
              :maxlength="form.observacao.maxlength"
              :noResize="true">
            </b-form-textarea>
          </div>
        </div>
      </div>
    </Forms>
    <AddSegmentationModal
      ref="addSegmentationModal"
      @reload="onGetAllSegmentation"
    />
    <AddTemplateModal
      ref="addTemplateModal"
      @reload="onGetAllTempalte"
    />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import NxDatePicker from '@/components/forms/NxDatePicker.vue'
import NxTimePicker from '@/components/forms/NxTimePicker.vue'

import EmailEnvioRepository from '@/shared/http/repositories/configurations/emailenvio.js'
import TemplateRepository from '@/shared/http/repositories/configurations/templates.js'
import SegmentationRepository from '@/shared/http/repositories/configurations/campaignlist.js'
import CampaignRepository from '@/shared/http/repositories/campaign/campaign.js'
import ParametroClasseA from '@/shared/http/repositories/configurations/parametroClasseA'
import NumRepository from '@/shared/http/repositories/access/cadastroNum'
import HsmRepository from '@/shared/http/repositories/configurations/hsm'

import CampaignModel from '@/shared/models/campaign/campaignmodel.js'
import CampaignForms from './campaignadd-form.js'
import AddSegmentationModal from './modal/addsegmentationmodal.vue'
import AddTemplateModal from './modal/addtemplatemodal.vue'

export default {
  name: 'CampaignAdd',
  mixins: [ActionsForm],
  components: {
    NxDatePicker,
    NxTimePicker,
    AddSegmentationModal,
    AddTemplateModal
  },
  data () {
    return {
      data: CampaignModel,
      form: CampaignForms,
      typeProvider: ''
    }
  },
  mounted () {
    this.onGetProvedores()
    this.onGetAllSegmentation()
    this.onGetAllTempalte()
    this.onGetAllAlias()
    this.onGetAllHms()
  },
  methods: {
    onLoad () {
      this.form.situacao.value = 1
    },
    onEdit (obj) {
      loading.push()

      if (obj) {
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.campanhaModelo) {
          this.form.campanhaModeloId.value = obj.campanhaModelo.id
        }
        if (obj.campanhaLista) {
          this.form.campanhaListaId.value = obj.campanhaLista.id
        }
        if (obj.dataEnvio) {
          const fusoHorarioLocal = this.moment.tz.guess()
          this.form.dataEnvio.value = this.moment.tz(new Date(obj.dataEnvio), fusoHorarioLocal).format('YYYY-MM-DD')
          this.form.horarioEnvio.value = this.moment.tz(new Date(obj.dataEnvio), fusoHorarioLocal).format('HH:mm')
        }
        this.form.plataforma.value = obj.plataforma ? obj.situacao : null
        this.form.situacao.value = obj.situacao ? obj.situacao : 1
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      this.data.nome = this.form.nome.value
      this.data.alias = this.form.alias.value
      if (this.form.provedorId.value) {
        this.data.provedorId = this.form.provedorId.value.id
      }
      if (this.data.dataEnvio) {
        var date = new Date(this.form.dataEnvio.value + 'T' + this.form.horarioEnvio.value)
        this.data.dataEnvio = date.toISOString()
      }
      CampaignRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.nome = this.form.nome.value
      if (this.data.dataEnvio) {
        var date = new Date(this.form.dataEnvio.value + 'T' + this.form.horarioEnvio.value)
        this.data.dataEnvio = date.toISOString()
      }
      CampaignRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onGetAllSegmentation () {
      loading.push()
      SegmentationRepository.GetAllSortedByNome()
        .then((response) => {
          this.form.campanhaListaId.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(this.onException)
    },
    onGetAllAlias () {
      EmailEnvioRepository.GetAll()
        .then((response) => {
          if (response.data && response.data.content && response.data.content.length > 0) {
            this.form.alias.options = response.data.content[0].aliases || []
          }
        })
        .catch(this.onException)
    },
    onGetAllHms () {
      HsmRepository.GetAll()
        .then((response) => {
          this.form.campanhaHsmId.options = this.onResultDropdown(response, null, f => f.hsmName)
        })
        .catch(this.onException)
    },
    onGetAllTempalte () {
      loading.push()
      TemplateRepository.GetAllSortedByNome()
        .then((response) => {
          this.form.campanhaModeloId.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(this.onException)
    },
    onAddSegmentationModal () {
      this.$refs.addSegmentationModal.showModal()
    },
    onEditSegmentationModal () {
      SegmentationRepository.GetById(this.form.campanhaListaId.value)
        .then((response) => {
          const { data } = response
          this.$refs.addSegmentationModal.onEdit(data)
        })
        .catch(this.onException)
    },
    onAddTemplateModal () {
      this.$refs.addTemplateModal.showModal()
    },
    onEditTemplateModal () {
      TemplateRepository.GetById(this.form.campanhaModeloId.value)
        .then((response) => {
          const { data } = response
          this.$refs.addTemplateModal.onEdit(data)
        })
        .catch(this.onException)
    },
    onGetProvedores () {
      NumRepository.getEnvAll()
        .then((response) => {
          const {data} = response
          const list = data.content.map(item => ({
            value: item,
            text: item.name
          }))
          this.form.provedorId.options = list
        })
        .catch(this.onException)
    },
    hasClasseA (val) {
      if (val === 2) {
        ParametroClasseA.GetAll()
          .then(response => {
            if (!response.data || !response.data.usuario) {
              toast.warning('Parametros de Classe A não cadastrados no sistema')
              this.form.plataforma.value = null
            }
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/campaign/components/add/campaignadd.vue